import React from "react";
import CommitteeMember from "./CommitteeMember";
import "../style/committee.scss";
import data from "../committee.json";

const Committee = () => {
  let arr1 = data.slice(0, 3);
  let arr2 = data.slice(3, 5);
  let arr3 = data.slice(5);
  return (
    <div className="committee">
      <div className="container">
        <div className="row">
          <div className="col s12">
            <h4 className="center">Meet the committee!</h4>
          </div>
        </div>
        <div className="row no-bottom">
          {arr1 &&
            arr1.map((person) => {
              return (
                <div className="col s12 l4 center" key={person.name}>
                  <CommitteeMember
                    committeeRole={person.role}
                    committeeName={person.name}
                    committeeTeam={person.team}
                    committeeAbout={person.about}
                    committeePhoto={person.photo}
                  />
                </div>
              );
            })}
        </div>
        <div className="row no-bottom">
          <div className="col l2" />
          {arr2 &&
            arr2.map((person) => {
              return (
                <div className="col s12 l4 center" key={person.name}>
                  <CommitteeMember
                    committeeRole={person.role}
                    committeeName={person.name}
                    committeeTeam={person.team}
                    committeeAbout={person.about}
                    committeePhoto={person.photo}
                  />
                </div>
              );
            })}
          <div className="col l2" />
        </div>
        <hr />
        <div className="row no-bottom">
          {arr3 &&
            arr3.map((person) => {
              return (
                <div className="col s12 l4 center" key={person.name}>
                  <CommitteeMember
                    committeeRole={person.role}
                    committeeName={person.name}
                    committeeTeam={person.team}
                    committeeAbout={person.about}
                    committeePhoto={person.photo}
                  />
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default Committee;
